import { usedCarsAPI, CAR_OFFERS_URL } from "@/api";
import { GET_INFO_ABOUT_CAR } from "@/store/actionTypes";

export default {
  async [GET_INFO_ABOUT_CAR]({ state }, CAR_ID) {
    const response = await usedCarsAPI().get(CAR_OFFERS_URL + CAR_ID);
    state.carInfo = response.data;
  }
};
